export default __webpack_public_path__ + "static/media/os-product-details.4e7c0de9.png";